import React from 'react';

export const DELIVERY_CONDITION_SUGGESTIONS = [
    'Good',
    'Minor Damage',
    'Damaged',
    'Wet',
    'Scuffed',
    'Handle broken',
];

/** Quick-fill chips for delivery condition; field stays editable after picking. */
export function ConditionSuggestionPills({ onPick, themeType }) {
    const outline = themeType === 'dark' ? 'btn-outline-light' : 'btn-outline-secondary';
    return (
        <div className="d-flex flex-wrap gap-1 mb-2">
            {DELIVERY_CONDITION_SUGGESTIONS.map(text => (
                <button
                    key={text}
                    type="button"
                    className={`btn btn-sm rounded-pill py-0 ${outline}`}
                    style={{ fontSize: '0.8rem' }}
                    onClick={() => onPick(text)}
                >
                    {text}
                </button>
            ))}
        </div>
    );
}
